import React from 'react';

const configs = { tenant: {}, organization: {} };
export default React.createContext(configs);
